export function shortAddress(address: string) {
  const firstLetters = address.substr(0, 6);
  const endingLetters = address.substr(-6, 6);
  return firstLetters + "..." + endingLetters;
}

export function getEtherscanAddressHref(address: string) {
  return `https://etherscan.io/address/${address}`;
}
